import React from "react";
import { Modal } from "antd";
import { getColorHex, normalizeHexColor } from "../../utils/identifyColor";

const OutOfStockModal = ({ visible, fabricName, colorName, colorValue, colorCode, onClose }) => {
  // Prioritize color_code if provided, otherwise use colorValue
  const colorData = colorCode ? { color_code: colorCode, color: colorValue } : { color: colorValue };
  const hexColor = getColorHex(colorData);
  const isWhite = hexColor?.toLowerCase() === '#ffffff' || hexColor?.toLowerCase() === '#fff';
  const shownColorText = (() => {
    const text = colorName || colorValue;
    const normalized = normalizeHexColor(text);
    return normalized || text;
  })();

  return (
    <Modal
      title={null}
      open={visible}
      onOk={onClose}
      onCancel={onClose}
      okText="OK"
      cancelButtonProps={{ style: { display: 'none' } }}
      width={400}
      styles={{
        content: {
          borderRadius: '32px',
          padding: 0,
          overflow: 'hidden',
        },
        body: {
          borderRadius: '12px',
          padding: '24px',
        },
        footer: {
          borderRadius: '0 0 12px 12px',
        },
      }}
    >
      <div style={{ textAlign: 'center', padding: '8px 0' }}>
        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: '#262626' }}>
            Out of Stock
          </h3>
        </div>
        <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
          <div style={{ 
            width: '32px', 
            height: '32px', 
            backgroundColor: hexColor || '#f0f0f0',
            border: isWhite ? '1px solid #d9d9d9' : 'none',
            borderRadius: '6px',
            flexShrink: 0,
          }} />
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '16px', fontWeight: 500, color: '#262626', marginBottom: '4px' }}>
              {fabricName}
            </div>
            <div style={{ fontSize: '14px', color: '#8c8c8c' }}>
              {shownColorText}
            </div>
          </div>
        </div>
        <div style={{ fontSize: '14px', color: '#ff4d4f', fontWeight: 500 }}>
          Quantity is out of stock
        </div>
      </div>
    </Modal>
  );
};

export default OutOfStockModal;

